import { GeneralThemeFormValues } from './generalTheme.types';

export const defaultGeneralTheme: GeneralThemeFormValues = {
  storeTabName: 'Gaming Store',
  logo: 'https://media.appcharge.com/defaults/default-store-logo.svg',
  favicon: 'https://media.appcharge.com/defaults/default-store-logo.svg',
  backgroundImageMobile: 'https://media.appcharge.com/defaults/background.png',
  backgroundImageDesktop: 'https://media.appcharge.com/defaults/background.png',
  storeSaleImage: '',
  loaderAnimation: 'https://media-dev.appcharge.com/media/defaults/circular-loader.json',
  font: 'montserrat',
  receiptHeader: '',
  footer: {
    imageMobile: '',
    imageDesktop: '',
    appstoreLink: '',
    googlePlayLink: '',
    privacyPolicyUrl: '',
    termsAndConditionsUrl: '',
    supportLink: '',
    openLinksInNewTab: false
  }
};
